import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import type { PeopleRow } from '../../outreachTypes';
import { detailsMessages as messages } from './detailsMessages';
/* eslint-disable css-modules/no-unused-class -- the shared chips of the Outreach area and one stylesheet for the details panel */
import shared from '../../Outreach.module.scss';
import styles from './Details.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** "Why Plug picked them" (design outreach-v2 t2): the fit as a bar, the reasons as chips. */
const PitchWhyCardComponent: React.FC<{ row: PeopleRow }> = ({ row }) => {
  const intl = useIntl();
  if (row.fit === null && row.why.length === 0) {
    return null;
  }
  return (
    <section className={styles.section} data-testid="pitch-why">
      <h3 className={styles.sectionHead}>{intl.formatMessage(messages.whyTitle)}</h3>
      {row.fit !== null && (
        <div className={styles.fitBar} aria-label={intl.formatMessage(messages.fitOf, { score: row.fit })}>
          <span className={styles.fitValue}>{row.fit}</span>
          <span className={styles.fitMeter} aria-hidden>
            {/* The bar fills to the score: a value of the row, not a style of the design. */}
            <i className={styles.fitFill} style={{ width: `${Math.min(100, Math.max(0, row.fit))}%` }} />
          </span>
        </div>
      )}
      {row.why.length > 0 && (
        <div className="d-flex flex-wrap gap-2">
          {row.why.map((label) => (
            <span key={label} className={shared.chip}>
              {label}
            </span>
          ))}
        </div>
      )}
    </section>
  );
};

export const PitchWhyCard = TypedMemo(PitchWhyCardComponent);
